export default __webpack_public_path__ + "static/media/french.c938fcf0.svg";